import { useQuery } from '@tanstack/react-query';

import { fetchChatHistory } from '../../fetch/fetchChatHistory';

export default function useFetchChatHistory(sessionId, isEnabled = true) {
  return useQuery({
    queryKey: ['xtramBotChatHistory', sessionId],
    queryFn: () => fetchChatHistory(sessionId),
    enabled: !!sessionId && isEnabled,
  });
}

